import { CheckIcon, XIcon } from "./Icons";
import type { Page } from "../types";

export function Pricing({ onNavigate }: { onNavigate: (p: Page) => void }) {
    const included = [
        "Application de commande personnalisée",
        "Commandes et produits illimités",
        "Paiement par carte bancaire (Stripe)",
        "Carte de fidélité digitale + All-Stars",
        "Coupons de réduction",
        "Emailing marketing (Booster)",
        "Notifications temps réel + alertes sonores",
        "Analytics, TVA, tickets, SEO",
        "PWA installable (comme une app native)",
        "Branding 100% personnalisable",
        "Support technique + mises à jour",
    ];
    const notIncluded = [
        "Aucune commission sur vos ventes",
        "Aucun frais caché",
        "Aucun engagement — résiliez quand vous voulez",
    ];

    return (
        <section className="py-12 px-6" id="tarif">
            <div className="text-center mb-12">
                <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-extrabold text-slate-900 leading-[1.2] tracking-tight mb-4">
                    Un prix simple. Tout inclus.
                </h2>
                <p className="text-[clamp(1.05rem,2vw,1.25rem)] text-slate-500 max-w-[680px] mx-auto leading-relaxed">
                    Pas de formule « Pro » ou « Enterprise ». Un seul tarif, toutes les fonctionnalités.
                </p>
            </div>
            <div className="max-w-[520px] mx-auto bg-white rounded-3xl p-12 max-sm:p-6 shadow-xl border-2 border-orange-500 text-center relative">
                <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-orange-500 text-white text-[0.82rem] font-bold px-5 py-1.5 rounded-full whitespace-nowrap">
                    Tarif tout inclus
                </div>
                <div className="flex items-baseline justify-center gap-1 mb-1">
                    <span className="text-[clamp(3rem,8vw,4.5rem)] font-black text-slate-900 leading-none">180€</span>
                    <span className="text-[1.1rem] text-slate-500">/an</span>
                </div>
                <div className="text-[0.9rem] text-slate-400 mb-8">soit 15€/mois, le prix d'une pizza !</div>
                <ul className="list-none text-left mb-8">
                    {included.map(f => (
                        <li key={f} className="py-2.5 border-b border-slate-200 last:border-b-0 flex items-center gap-3 text-[0.95rem]">
                            <CheckIcon size={20} className="text-emerald-500 shrink-0" /> {f}
                        </li>
                    ))}
                </ul>
                <ul className="list-none text-left mb-8 pt-3 border-t-2 border-dashed border-slate-200">
                    {notIncluded.map(f => (
                        <li key={f} className="py-1.5 flex items-center gap-3 text-[0.9rem] text-slate-500">
                            <XIcon size={18} className="text-slate-400 shrink-0" /> {f}
                        </li>
                    ))}
                </ul>
                <button onClick={() => onNavigate("contact")} className="w-full inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-[1.05rem] font-bold bg-orange-500 text-white shadow-[0_4px_14px_rgba(249,115,22,0.35)] hover:bg-orange-600 hover:translate-y-[-2px] hover:shadow-[0_6px_20px_rgba(249,115,22,0.4)] transition-all cursor-pointer border-none">
                    Démarrer maintenant — 180€/an →
                </button>
                <p className="text-[0.82rem] text-slate-400 mt-5 leading-relaxed">
                    Seuls frais en plus : les frais bancaires Stripe (1,4% + 0,25€ par transaction) — le minimum pour accepter les cartes bancaires, quel que soit le prestataire.
                </p>
            </div>
        </section>
    );
}
